<template>
  <component
    :is="tag"
    class="d-flex align-items-center p-0 cursor-pointer"
    :class="itemClassList"
    :style="itemStyle"
  >
    <button
      class="selection-toggle bg-transparent border-0 ml-3 pl-0"
      type="button"
      :disabled="isDisabled"
      :aria-label="toggleLabel"
      @click.stop="toggle"
    >
      <font-awesome-icon
        :icon="icon"
        size="lg"
        class="text-primary"
        aria-hidden="true"
      />
    </button>

    <button
      class="territory-navigation-button d-flex align-items-center flex-grow-1 bg-transparent border-0 py-3 pr-3 text-left"
      type="button"
      :disabled="isSelectDisabled"
      :aria-current="active && showNavigationIcon ? 'true' : null"
      @click="select"
    >
      <span class="flex-grow-1 p-0 text-left">
        <slot />
      </span>

      <span
        v-if="coverageLabel"
        class="coverage-badge badge badge-pill badge-primary ml-2 flex-shrink-0"
        v-text="coverageLabel"
      />

      <font-awesome-icon
        v-if="isVisibleNavigationIcon"
        icon="arrow-right"
        class="text-primary opacity-5 ml-2"
        title="Contexto ativo"
        aria-hidden="true"
      />
    </button>
  </component>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "SelectMultiMunicipioListItem",
  props: {
    tag: {
      type: String,
      default: "b-list-group-item",
    },
    icon: {
      type: [String, Array, Object],
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inherited: {
      type: Boolean,
      default: false,
    },
    allowInheritedSelection: {
      type: Boolean,
      default: true,
    },
    navigateOnToggle: {
      type: Boolean,
      default: false,
    },
    showNavigationIcon: {
      type: Boolean,
      default: false,
    },
    coverageLabel: {
      type: String,
      default: "",
    },
    toggleLabel: {
      type: String,
      default: "Alterar seleção",
    },
    itemClass: {
      type: [String, Array, Object],
      default: "",
    },
    itemStyle: {
      type: [String, Array, Object],
      default: "",
    },
  },
  emits: ["select", "toggle"],
  setup(props, { emit }) {
    const isDisabled = computed(() => props.disabled);
    const isSelectDisabled = computed(
      () =>
        props.disabled || (!props.allowInheritedSelection && props.inherited)
    );

    const isVisibleNavigationIcon = computed(
      () => props.active && props.showNavigationIcon
    );

    const itemClassList = computed(() => [
      { "active-item": props.active },
      props.itemClass,
    ]);

    function select() {
      if (isSelectDisabled.value) return;

      emit("select");
    }

    function toggle() {
      if (props.disabled) return;

      emit("toggle");

      if (props.navigateOnToggle) emit("select");
    }

    return {
      isDisabled,
      isSelectDisabled,
      itemClassList,
      isVisibleNavigationIcon,
      select,
      toggle,
    };
  },
});
</script>

<style scoped lang="scss">
.active-item {
  color: var(--primary);
  background-color: rgba(var(--primary-rgb), 0.095);
}

.cursor-pointer:hover:not(.active-item) {
  color: var(--primary);
  background-color: rgba(var(--primary-rgb), 0.025);
}

.indeterminate-icon {
  font-size: 0.5rem;
}

.coverage-badge {
  font-size: 0.7rem;
  font-weight: 600;
  background-color: rgba(var(--primary-rgb), 0.1);
}

.selection-toggle:focus,
.territory-navigation-button:focus {
  outline: none;
}

.territory-navigation-button {
  color: inherit;
  min-width: 0;
}
</style>
